import "../assets/common6.css";
import { c as t } from "./index.bddf5ebb.js";
const b = "_collapse_phb9b_1", o = "_wrapper_phb9b_19", a = "_header_phb9b_24", l = "_label_phb9b_44", n = "_medium_phb9b_53", p = "_large_phb9b_59", r = "_body_phb9b_71", d = "_heading_phb9b_91", h = "_content_phb9b_98", m = "_selected_phb9b_113", e = {
  collapse: b,
  wrapper: o,
  header: a,
  label: l,
  medium: n,
  large: p,
  body: r,
  heading: d,
  content: h,
  selected: m
}, u = ({
  className: s,
  isSelected: c,
  size: _
}) => t([e.collapse, s], {
  [e.selected]: !!c,
  [e[_]]: _ !== "small"
});
export {
  u as c,
  e as s
};
//# sourceMappingURL=common.47956ba6.js.map
